<template>
  <div v-if="consumerUnit && consumerUnit.id">
    <v-tabs
      v-model="active"
      color="grey"
      dark
      grow
      mandatory
      slider-color="blue"
    >
      <v-tab ripple>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn flat>
              <v-icon v-on="on">house</v-icon>
            </v-btn>
          </template>
          <span>Dados da Unidade Consumidora</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item>
        <ConsumerUnit />
      </v-tab-item>

      <v-tab ripple>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn flat>
              <v-icon v-on="on">account_balance_wallet</v-icon>
            </v-btn>
          </template>
          <span>Faturas</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item>
        <Billings :consumerUnit="consumerUnit" v-if="!loading" />
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="success"
          indeterminate
        ></v-progress-circular>
      </v-tab-item>

      <v-tab ripple>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn flat>
              <v-icon v-on="on">list</v-icon>
            </v-btn>
          </template>
          <span>Parcelamentos</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item>
        <Installments :consumerUnit="consumerUnit" v-if="!loading" />
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="success"
          indeterminate
        ></v-progress-circular>
      </v-tab-item>

      <v-tab ripple>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn flat>
              <v-icon v-on="on">wallet</v-icon>
            </v-btn>
          </template>
          <span>Faturas Especiais</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item>
        <SpecialBillings :consumerUnit="consumerUnit" v-if="!loading" />
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="success"
          indeterminate
        ></v-progress-circular>
      </v-tab-item>

      <v-tab ripple>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn flat>
              <v-icon v-on="on">price_change</v-icon>
            </v-btn>
          </template>
          <span>Valores Provisionados</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item>
        <ProvisionedBillings :consumerUnit="consumerUnit" v-if="!loading" />
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="success"
          indeterminate
        ></v-progress-circular>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Billings from "./Billings";
import ConsumerUnit from "./ConsumerUnit";
import Installments from "./Installments";
import ProvisionedBillings from "./ProvisionedBillings";
import SpecialBillings from "./SpecialBillings";

export default {
  components: {
    Billings,
    ConsumerUnit,
    Installments,
    SpecialBillings,
    ProvisionedBillings,
  },
  computed: {
    ...mapState("cs", ["activeBilling"]),
    consumerUnit() {
      if (
        this.$store.state &&
        this.$store.state &&
        this.$store.state.cs.consumerUnit
      )
        return this.$store.state.cs.consumerUnit;
      else return null;
    },
    activeBilling() {
      if (
        this.$store.state &&
        this.$store.state &&
        this.$store.state.cs.activeBilling
      )
        return this.$store.state.cs.activeBilling;
      else return 0;
    },
  },
  watch: {
    async active() {
      this.setActiveBilling(this.active);
      if (this.active === 1) {
        this.loading = true;
        await this.getBillingByConsumerUnit(this.consumerUnit.id);
        this.loading = false;
      } else if (this.active === 3) {
        this.loading = true;
        await this.getSpecialBillings(this.consumerUnit);
        this.loading = false;
      } else if (this.active === 4) {
        this.loading = true;
        await this.getProvisionedBillings(this.consumerUnit);
        this.loading = false;
      }
    },
    async activeBilling() {
      this.active = this.activeBilling;
    },
  },
  methods: {
    ...mapActions("cs", [
      "getBillingByConsumerUnit",
      "getSpecialBillings",
      "getProvisionedBillings",
    ]),
    ...mapMutations("cs", ["setActiveBilling"]),
  },
  mounted() {
    this.active = this.activeBilling || 0;
  },
  data() {
    return {
      active: 0,
      loading: false,
    };
  },
};
</script>

<style scoped>
::v-deep .v-tabs__item {
  padding: 0px !important;
}
</style>
